module.exports = __webpack_public_path__ + "img/client (9).577d8b02.jpg";